module.exports = __webpack_public_path__ + "img/inMeeting.fb94a64a.png";